// libraries
import React from "react";
// schema
import { CalendarTimeStats, UserWorkingHours } from "@clockwise/schema";
// components
import { TimeAllocation } from "#webapp/src/components/time-allocation";
import { ProfileTimeOverWeek } from "./ProfileTimeOverWeek";
// assets and CSS
import { brokenClock } from "#webapp/src/assets/img/illustrations";
import * as s from "./ProfileTimeVisualizations.styles";

type ProfileTimeVisualizationsProps = {
  calendarTimeStats: CalendarTimeStats | null;
  userWorkingHours: UserWorkingHours | null;
};

const ProfileTimeVisualizationsError = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        textAlign: "center",
        background: "#fff",
      }}
    >
      <img style={{ width: 200 }} src={brokenClock} alt="broken clock" />
      <div style={{ marginTop: 15 }}>
        We couldn't load analytics. Please try again in a few minutes.
      </div>
    </div>
  );
};

export const ProfileTimeVisualizations = ({
  calendarTimeStats,
  userWorkingHours,
}: ProfileTimeVisualizationsProps) => {
  if (!calendarTimeStats || !userWorkingHours) return null;

  const maybeRenderError = (calendarTimeStats: CalendarTimeStats) => {
    if (
      calendarTimeStats.totalMinutes === null ||
      calendarTimeStats.focusMinutes === null ||
      calendarTimeStats.busyMinutes === null ||
      calendarTimeStats.fragmentedMinutes === null ||
      calendarTimeStats.unclassifiedMinutes === null
    ) {
      return <ProfileTimeVisualizationsError />;
    }

    return null;
  };

  const {
    focusMinutes,
    busyMinutes,
    fragmentedMinutes,
    unclassifiedMinutes,
    totalMinutes,
  } = calendarTimeStats;
  return (
    <div>
      <div className="cw-heading-base cw-mb-2" style={s.title}>
        Time allocation
      </div>
      <div style={{ position: "relative" }}>
        <TimeAllocation
          focusMinutes={focusMinutes}
          busyMinutes={busyMinutes}
          fragmentedMinutes={fragmentedMinutes}
          unclassifiedMinutes={unclassifiedMinutes}
          totalMinutes={totalMinutes}
        />
        <ProfileTimeOverWeek
          calendarTimeStats={calendarTimeStats}
          userWorkingHours={userWorkingHours}
        />
        {maybeRenderError(calendarTimeStats)}
      </div>
    </div>
  );
};
